import React from 'react';
import { Button } from '@mui/material';

const UploadButton = ({ disabled, onChange }) => (
  <>
    <input
      accept="image/*"
      name="photo"
      onClick={event => (event.target.value = '')}
      style={{ display: 'none' }}
      id="contained-button-file"
      multiple
      type="file"
      onChange={onChange}
      disabled={disabled}
    />
    <label htmlFor="contained-button-file">
      <Button disabled={disabled} fullWidth variant="contained" color="secondary" component="span">
        Add rescue photo
      </Button>
    </label>
  </>
);

export default UploadButton;
